import fetchJSONHandleError from 'utils/NET/fetchJSONHandleError'
import { BACKEND_PIVOT } from 'core/constants/endpoints'

function getFeaturePlansRecommended({ location, agent_id }) {
  return fetchJSONHandleError({
    url: `${BACKEND_PIVOT}/maintenance/featured-plan/agent/${agent_id}/state/${location.state_acronym}`
  })
}

export default getFeaturePlansRecommended
